import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getCustomers } from "../../api/apiCustomers";

export const useGetCustomers = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["customers", params, i18next.language],
        queryFn: () => getCustomers(params),
        keepPreviousData: true,
    });

    const root = data?.data;
    let customers = [];
    let meta = data?.meta;

    if (Array.isArray(root)) {
        customers = root;
    } else if (root && Array.isArray(root.data)) {
        customers = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        customers,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: customers.length },
        refetch,
    };
};
